function build(txt, img, tre) {
    let struttura = [];
    let temp;

    temp=(<h2 className="subtitle">{txt[0]}</h2>);
    struttura.push(temp);

    temp=(<div className="paragrafo">{txt[1]}</div>);
    struttura.push(temp);

    
  temp = (
    <div className="paragrafo">
      {txt[2]}
      {img[0]}
    </div>
  );
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {img[1]}
      {txt[3]}
    </div>
  );
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {txt[4]}
      {img[2]}
    </div>
  );
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {img[3]}
      {txt[5]}
    </div>
  );
  struttura.push(temp);

  temp=(<div className="paragrafo">{txt[6]}{img[4]}</div>);
  struttura.push(temp);

  temp=(<h2 className="subtitle">{txt[7]}</h2>);
  struttura.push(temp);

  temp=(<div className="note">{txt[8]}</div>);
  struttura.push(temp);
  
  
  return struttura;
}
  
export default build;
  